import { Container, Loading } from './Styles';

const Loader = ({ fullHeight, size, width, color }) => (
  <Container $fullHeight={fullHeight}>
    <Loading $size={size} $width={width} $color={color} />
  </Container>
);

export default Loader;
